var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { ConnectionQuality } from 'livekit-client';
import { useAppSelector } from '../../../../store';
import { participantsSelector } from '../../../../store/slices/participantSlice';
const ConnectionStatus = ({ userId }) => {
    _react_refresh_temp_2();
    const participant = useAppSelector((state) => participantsSelector.selectById(state, userId));
    const [color, setColor] = useState('#FFFFFF');
    useEffect(() => {
        switch (participant === null || participant === void 0 ? void 0 : participant.connectionQuality) {
            case ConnectionQuality.Excellent:
                setColor('#38f105');
                break;
            case ConnectionQuality.Good:
                setColor('#c8f6bd');
                break;
            case ConnectionQuality.Poor:
                setColor('#FF0000');
                break;
            case ConnectionQuality.Lost:
                setColor('#e03131');
                break;
            default:
                setColor('#FFFFFF');
        }
    }, [participant === null || participant === void 0 ? void 0 : participant.connectionQuality]);
    const render = () => {
        return _jsx("i", { style: { color: color }, className: "pnm-network text-[7px]" });
    };
    return _jsx("div", { className: "connection-status", children: render() });
};
_react_refresh_temp_1 = ConnectionStatus;
$RefreshReg$(_react_refresh_temp_1, "ConnectionStatus");
_react_refresh_temp_2(ConnectionStatus, "onLlmk+o3KsVizyOQWA5YVAvIH0=", false, () => [useAppSelector]);
export default ConnectionStatus;
